import { render, staticRenderFns } from "./approval-view.vue?vue&type=template&id=5ff16107&scoped=true&"
import script from "./approval-view.vue?vue&type=script&lang=js&"
export * from "./approval-view.vue?vue&type=script&lang=js&"
import style0 from "./approval-view.vue?vue&type=style&index=0&id=5ff16107&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff16107",
  null
  
)

export default component.exports